import $, { data } from 'jquery';
import NavbarFullScreen from './NavbarFullScreen';
/* ===============================================================
  Search
=============================================================== */
class Search {
    // Initialize
    constructor() {
        // Get search box
        this.searchBox = $('#irantheme-search-box');
        // Get search form
        this.searchForm = $('.irantheme-search-form');
        // Get search toggle button (Show/hide)
        this.searchIconToggle = $('.irantheme-search-box-toggle');
        // Get close button search box
        this.searchCloseButton = $('#irantheme-search-box-close');
        // Get search input
        this.searchInput = this.searchForm.find('.irantheme-search-input');
        // Get spinner icon alt
        this.spinnerAlt = this.searchForm.find('#irantheme-spinner-alt');
        // Get search icon alt
        this.searchAlt = this.searchForm.find('#irantheme-search-alt');
        // Get search results
        this.searchResults = this.searchForm.find('.irantheme-search-results');
        // Get search results holder Products
        this.searchResultsProducts = this.searchForm.find(
            '.irantheme-search-results-holder .irantheme-search-results-products',
        );
        // Get search results holder Posts
        this.searchResultsPosts = this.searchForm.find(
            '.irantheme-search-results-holder .irantheme-search-results-posts',
        );
        // Get search results prev
        this.searchResultsPrev = this.searchForm.find(
            '.irantheme-search-results-prev',
        );
        // Get categories buttons
        this.categoriesButtons = this.searchForm.find(
            '.irantheme-search-categories .irantheme-search-category-item',
        );
        // Get search category selection
        this.searchCategories = this.searchForm.find(
            '.irantheme-search-categories',
        );
        // Get search not found
        this.searchNotFound = this.searchForm.find(
            '.irantheme-search-results-not-found',
        );
        this.navbarFullScreen = new NavbarFullScreen();

        // Add tracking variables
        this.lastSearchedCategory = null;
        this.trackingTimer = null;
        this.minSearchLength = 2; // Minimum characters to track

        this.events();
        this.timer;
        this.previousSearchInputValue = '';
        this.spinnerStatus = false;
        this.isOpen = false;
        // Status products search not found
        this.statusProductsSearchNotFound = false;
        // Status posts search not found
        this.statusPostsSearchNotFound = false;
    }

    // Events
    events() {
        // Toggle and close form
        this.searchIconToggle.on('click', () => {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        });
        this.searchCloseButton.on('click', () => {
            this.close();
        });
        // Trigger keypress
        $(document).on('keydown', (e) => {
            this.keyPressDispatcher(e);
        });

        // Check status ajax
        if (this.searchForm.data('ajax') == 'on') {
            // Focus input and show search results
            this.searchInput.focus((e) => {
                let searchForm = $(e.target).parents('.irantheme-search-form');
                if (this.searchResultsPrev.length) {
                    $(searchForm).find('.irantheme-search-results').fadeIn(500);
                }
            });
            // Trigger keyup
            this.searchInput.on('keyup', (e) => {
                let searchForm = $(e.target).parents('.irantheme-search-form');
                // Get input search input value
                var searchInputValue = $(e.target).val();
                // Check search input value with previous value & length
                if (searchInputValue != this.previousSearchInputValue) {
                    clearTimeout(this.timer);
                    // Check search input value
                    if (searchInputValue) {
                        // Enable spinner
                        this.enableSpinner(searchForm);
                        this.timer = setTimeout(() => {
                            this.searchResultsPrev.hide();
                            this.statusProductsSearchNotFound = false;
                            this.statusPostsSearchNotFound = false;
                            // Get live search data
                            this.trigger(searchForm);
                        }, 1000);
                    } else {
                        this.searchResultsPosts.html('');
                        this.searchResultsProducts.html('');
                        this.searchNotFound.hide();
                        this.disableSpinner(searchForm);
                        if (this.searchResultsPrev.length) {
                            this.searchResultsPrev.fadeIn(250);
                        } else {
                            this.searchResults.fadeOut(250);
                        }
                    }
                }
                this.previousSearchInputValue = searchInputValue;
            });
            // Hide search results
            $(document).on('click', (e) => {
                if (!$(e.target).closest('.irantheme-search-form').length) {
                    this.searchResults.fadeOut(500);
                }
            });
            // Active category button on click
            this.categoriesButtons.on('click', (e) => {
                // Prevent to submit form
                e.preventDefault();
                // Get element target
                let element = $(e.target);
                // Is element tag (i)
                if ($(e.target).prop('tagName') == 'I') {
                    // Assign correct element
                    element = $(element).parent();
                }
                // Check active class
                if (!$(element).hasClass('active')) {
                    // Remove active from all buttons
                    this.categoriesButtons.removeClass('active');
                    // Add active class
                    $(element).addClass('active');
                }
            });

            // Track category search on form submission
            this.searchForm.on('submit', (e) => {
                e.preventDefault();
                this.trackCategorySearch();
            });
        }
    }

    trigger(parent) {
        // Get admin ajax url
        var ajax_url = iranthemeWpData.adminAjax;
        // Get input value
        var InputValue = $(parent).find('.irantheme-search-input').val();
        let searchResults = $(parent).find('.irantheme-search-results');
        let searchResultsPosts = $(parent).find(
            '.irantheme-search-results-posts',
        );
        let searchResultsProducts = $(parent).find(
            '.irantheme-search-results-products',
        );
        let searchNotFound = $(parent).find(
            '.irantheme-search-results-not-found',
        );

        // Get active category for tracking
        const activeCategory = this.getActiveCategoryAction(parent);
        this.lastSearchedCategory = activeCategory;

        // Product fetch =============================================
        jQuery.ajax({
            url: ajax_url,
            type: 'post',
            data: {
                action: 'get_wc_title',
                search_input: InputValue,
                search_category: activeCategory,
            },
            dataType: 'html',
            beforeSend: (response) => {
                $(searchResults).show();
                // Empty search result elements
                $(searchResultsPosts).empty();
                $(searchResultsProducts).empty();
                $(searchNotFound).hide();
            },
            success: (response) => {
                let posts = $(response).find('.irantheme-search-result-post');
                if (posts.length) {
                    $(searchResultsProducts).append(response);
                    // Track category if search was successful and has minimum length
                    if (
                        InputValue &&
                        InputValue.length >= this.minSearchLength &&
                        activeCategory &&
                        activeCategory !== '-1'
                    ) {
                        this.trackCategorySearch(InputValue);
                    }
                } else {
                    this.statusProductsSearchNotFound = true;
                }
            },
            complete: (response) => {
                // Stop spinner!
                this.disableSpinner(parent);
                if (
                    this.statusProductsSearchNotFound &&
                    this.statusPostsSearchNotFound
                ) {
                    $(searchNotFound).show();
                }
            },
            error: () => {},
        });

        // Post fetch =============================================
        jQuery.ajax({
            url: ajax_url,
            type: 'post',
            data: {
                action: 'data_fetch',
                search_input: InputValue,
                search_category: activeCategory,
            },
            dataType: 'html',
            beforeSend: (response) => {
                $(searchResults).show();
                // Empty search result elements
                $(searchResultsPosts).empty();
                $(searchResultsProducts).empty();
                $(searchNotFound).hide();
            },
            success: (response) => {
                let products = $(response).find(
                    '.irantheme-search-result-post',
                );
                if (products.length) {
                    $(searchResultsPosts).append(response);
                } else {
                    this.statusPostsSearchNotFound = true;
                }
            },
            complete: (response) => {
                // Stop spinner!
                this.disableSpinner(parent);
                if (
                    this.statusProductsSearchNotFound &&
                    this.statusPostsSearchNotFound
                ) {
                    $(searchNotFound).show();
                }
            },
            error: () => {},
        });
    }

    // Track category search
    trackCategorySearch(InputValue) {
        const activeCategory = this.getActiveCategoryAction(this.searchForm);

        // Don't track if no category selected or category is "all" or search term is too short
        if (
            !activeCategory ||
            activeCategory === '-1' ||
            InputValue.length < this.minSearchLength
        ) {
            return;
        }

        // Send tracking request
        jQuery.ajax({
            url: iranthemeWpData.adminAjax,
            type: 'POST',
            data: {
                action: 'track_category_search',
                category_id: activeCategory,
                nonce: iranthemeWpData.nonce,
            },
            success: (response) => {
                if (response.success) {
                    console.log('Category search tracked:', activeCategory);
                }
            },
            error: (error) => {
                console.error('Error tracking category search:', error);
            },
        });
    }

    // Open search form
    open() {
        // This line is for opening search form in fullscreen mode
        this.navbarFullScreen.close();
        this.searchBox.slideDown(500);
        this.isOpen = true;
        this.searchIconToggle
            .find('.irantheme-navbar-options-list-item-link')
            .addClass('active');
        setTimeout(() => {
            $(this.searchBox).find('.irantheme-search-input').focus();
        }, 501);
    }

    // Close search form
    close() {
        this.searchBox.slideUp(500);
        this.isOpen = false;
        this.searchIconToggle
            .find('.irantheme-navbar-options-list-item-link')
            .removeClass('active');
    }

    // Open & close with keypress
    keyPressDispatcher(e) {
        if (
            e.keyCode == 83 &&
            !this.isOpen &&
            !$('input, textarea').is(':focus')
        ) {
            this.open();
        }
        if (e.keyCode == 27 && this.isOpen) {
            this.close();
        }
    }

    // Spinner alt active (Rotate)
    enableSpinner(parent) {
        // Get spinner icon alt
        let spinnerAlt = $(parent).find('#irantheme-spinner-alt');
        // Get search icon alt
        let searchAlt = $(parent).find('#irantheme-search-alt');
        $(searchAlt).hide();
        $(spinnerAlt).show();
    }

    // Search alt active (Disable rotate spinner)
    disableSpinner(parent) {
        // Get spinner icon alt
        let spinnerAlt = $(parent).find('#irantheme-spinner-alt');
        // Get search icon alt
        let searchAlt = $(parent).find('#irantheme-search-alt');
        $(searchAlt).show();
        $(spinnerAlt).hide();
    }

    // Get button active in search categories
    getActiveCategoryAction(parent) {
        // Get active category
        let category = $(parent).find(
            '.irantheme-search-results .irantheme-search-categories .irantheme-search-category-item.active',
        );
        // Get data category
        let buttonCategoryData = jQuery(category).data('cate');
        return buttonCategoryData;
    }
}

export default Search;
